import React from 'react';
import styles from './ModalWidget.scss';
import { InjectedTranslateProps, translate } from 'react-i18next';
import Button from '../Button/Button';
import { headerFontFamily, messagesFontFamily } from '../../reducers';
import { connect } from 'react-redux';

interface ModalWidgetProps extends InjectedTranslateProps {
  fontColor: string;
  title: string;
  description: string;

  primaryButtonText: string;
  primaryButtonCallback: any;

  secondaryButtonText: string;
  secondaryButtonCallback: any;

  messageFont: string;
  headerFont: string;
}

class ModalWidget extends React.Component<ModalWidgetProps> {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      fontColor,
      title,
      description,
      primaryButtonCallback,
      primaryButtonText,
      secondaryButtonCallback,
      secondaryButtonText,
      headerFont,
      messageFont,
    } = this.props;

    return (
      <div
        className={styles.modalWrapper}
        style={{ fontFamily: messageFont, color: fontColor }}
      >
        <div className={styles.title} data-hook={'title'}>
          {title}
        </div>
        <div className={styles.description} data-hook={'description'}>
          {description}
        </div>
        <div className={styles.buttons} style={{ fontFamily: headerFont }}>
          <div className={styles.secondaryButton}>
            <Button
              dataHook="secondaryButton"
              onClick={secondaryButtonCallback}
              lightButton={true}
            >
              {secondaryButtonText}
            </Button>
          </div>
          <div className={styles.defaultButton}>
            <Button dataHook="defaultButton" onClick={primaryButtonCallback}>
              {primaryButtonText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messageFont: messagesFontFamily(state),
  headerFont: headerFontFamily(state),
});

export default connect(mapStateToProps)(translate()(ModalWidget));
